import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Doughnut } from "react-chartjs-2";

import { defaultOptions, defaultPlugins, defaultRootPlugins, donutPlugins } from "./config";
import "./styles.css";

const DoughnutChart = ({ title, data, parser, cutout, tooltipPosition = "auto" }) => {
  const formattedData = useMemo(() => {
    const labels = [];
    const dataset = [];
    const colors = [];

    data.forEach((datum) => {
      labels.push(datum[parser.x]);
      dataset.push(datum[parser.y]);
      colors.push(datum.color);
    });

    return { labels, datasets: [{ data: dataset, backgroundColor: colors, hoverBackgroundColor: colors }] };
  }, [ data, parser ]);

  const optionPlugins = {
    ...defaultPlugins,
    ...donutPlugins,
    title,
    tooltip: {
      ...donutPlugins.tooltip,
      customPosition: tooltipPosition, // 👈 attach the positioning option
    },
  };

  if (!formattedData.labels.length) {
    optionPlugins["emptyDoughnut"] = { color: "#FFFFFF", width: 0.2, radiusDecrease: 0 };
  };

  return (
    <Doughnut
      datasetIdKey="idx"
      options={{
        ...defaultOptions,

        cutout: cutout || 60,
        plugins: optionPlugins,
      }}
      data={formattedData}
      plugins={defaultRootPlugins}
    />
  )
};

DoughnutChart.propTypes = {
  title: PropTypes.string,
  data: PropTypes.array,
  parser: PropTypes.shape({
    x: PropTypes.string,
    y: PropTypes.string,
  }),
};

export default DoughnutChart;
